import React from 'react'
import styles from './Transaction.module.css';
import PDFIcon from '../../../src/assets/images/icon/pdficon.svg'

const newnine = () => {
    const data = [
        {
          invoiceId: "INV241214123",
          subscriptionDetails: "1 month Database Plan",
          transactionDetails: {
            txnNo: "154648489496",
            amount: 1689,
            date: "01-11-2024",
          },
          invoiceLink: "08-11-2024 Invoice.pdf",
        },
        {
          invoiceId: "INV241246130",
          subscriptionDetails: "1 month Database Plan",
          transactionDetails: {
            txnNo: "154648489496",
            amount: 1689,
            date: "01-10-2024",
          },
          invoiceLink: "08-10-2024 Invoice.pdf",
        },
        
        {
            invoiceId: "INV241246130",
            subscriptionDetails: "1 month Database Plan",
            transactionDetails: {
              txnNo: "154648489496",
              amount: 1689,
              date: "01-10-2024",
            },
            invoiceLink: "08-10-2024 Invoice.pdf",
          },
          
        {
            invoiceId: "INV241246130",
            subscriptionDetails: "1 month Database Plan",
            transactionDetails: {
              txnNo: "154648489496",
              amount: 1689,
              date: "01-10-2024",
            },
            invoiceLink: "08-10-2024 Invoice.pdf",
          },
          {
            invoiceId: "INV241246130",
            subscriptionDetails: "1 month Database Plan",
            transactionDetails: {
              txnNo: "154648489496",
              amount: 1689,
              date: "01-10-2024",
            },
            invoiceLink: "08-10-2024 Invoice.pdf",
          },
          {
            invoiceId: "INV241246130",
            subscriptionDetails: "1 month Database Plan",
            transactionDetails: {
              txnNo: "154648489496",
              amount: 1689,
              date: "01-10-2024",
            },
            invoiceLink: "08-10-2024 Invoice.pdf",
          },
          {
            invoiceId: "INV241246130",
            subscriptionDetails: "1 month Database Plan",
            transactionDetails: {
              txnNo: "154648489496",
              amount: 1689,
              date: "01-10-2024",
            },
            invoiceLink: "08-10-2024 Invoice.pdf",
          },
      ];
  return (
    <div className='mt-1'>
        <div className='container-fluid'>
            <div className='row'>
                <div className='col-md-12'>
                    <div className={`${styles['transaction-card']} pb-3`}>
                        <h1 className='py-3'>Transaction Details</h1>
                        <div className={`${styles['inner-card']} tabel-responsive`}>
                        <table className="table table-striped table-bordered pb-3">
        <thead className={`${styles['tb-head']}`}>
          <tr>
            <th>Invoice ID</th>
            <th>Subscription Details</th>
            <th>Transaction Details</th>
            <th>Invoice</th>
          </tr>
        </thead>
        <tbody className={`${styles['td-body']}`}>
          {data.map((item, index) => (
            <tr key={index}>
              <td>{item.invoiceId}</td>
              <td>{item.subscriptionDetails}</td>
              <td>
                <p>Txn No.: {item.transactionDetails.txnNo}</p>
                <p>Amount: {item.transactionDetails.amount}</p>
                <p>Date: {item.transactionDetails.date}</p>
              </td>
              <td>
                <img src={PDFIcon}/>
                <a className={`${styles['dwn-item']} ps-2`} href={`#${item.invoiceLink}`}>
                  <i className="bi bi-file-earmark-pdf"></i> {item.invoiceLink}
                </a>
                
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <nav>
        <ul className="pagination justify-content-center">
          <li className="page-item disabled">
            <button className="page-link">Previous</button>
          </li>
          <li className="page-item active">
            <button className="page-link">1</button>
          </li>
          <li className="page-item">
            <button className="page-link">2</button>
          </li>
          <li className="page-item">
            <button className="page-link">3</button>
          </li>
          <li className="page-item">
            <button className="page-link">Next</button>
          </li>
        </ul>
      </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default newnine